import { render, staticRenderFns } from "./repartocontratacion.vue?vue&type=template&id=88083e9c&scoped=true"
import script from "./repartocontratacion.vue?vue&type=script&lang=js"
export * from "./repartocontratacion.vue?vue&type=script&lang=js"
import style0 from "./repartocontratacion.vue?vue&type=style&index=0&id=88083e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88083e9c",
  null
  
)

export default component.exports